var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 4.6,
    r: 1.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 7.2,
    width: 2.4,
    height: 9.6,
    rx: 0.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2 7.2H10.4V8.45C10.75 7.9 11.6 7.05 13.25 7.05C16.15 7.05 16.8 8.95 16.8 11.4V16.8H14.4V11.95C14.4 10.6 14.35 8.9 12.6 8.9C10.85 8.9 10.55 10.25 10.55 11.85V16.8H8.2V7.2Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSvg);
export default __webpack_public_path__ + "static/media/linkedin-svg.28a2af8780d15ef058d698f117fda56b.svg";
export { ForwardRef as ReactComponent };